import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import { graphAxisLines, graphWallFill } from './';
import { decreaseLumaDelta } from '../util';

export const graphGridLines = (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
  const common = {
    lineThickness: graphAxisLines(theme, parameters).lineThickness,
  };
  switch (theme.baseThemeName) {
    case 'dark': {
      return {
        ...common,
        lineColor: graphAxisLines(theme, parameters).lineColor,
        lineStyle: 'dot',
        lineTransparency: 0.6,
        gridLayer: 'front',
      };
    }
    case 'high-contrast': {
      return {
        ...common,
        lineColor: decreaseLumaDelta(
          graphAxisLines(theme, parameters).lineColor,
          graphWallFill(theme, parameters).fillColor,
          41,
          true
        ),
        lineStyle: 'shortdash',
        lineTransparency: 0,
        gridLayer: 'back',
      };
    }
    default: {
      return {
        ...common,
        lineColor: graphAxisLines(theme, parameters).lineColor,
        lineStyle: 'dot',
        lineTransparency: 0.6,
        gridLayer: 'front',
      };
    }
  }
};
